import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import WorkerAllocate from '@/views/Dialog/WorkerAllocate/index.vue';
import vuexStore from '@/vuex-store';
import { useWorkerAllocate } from '@/use/useWorkerAllocate';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { nextTick, onMounted, } from 'vue';
import { initAutoLc } from '@/locales/ko/views/worker_allocate';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PopupWrapper',
    setup(__props) {
        // 라이더 배차 팝업 (팝업 아우터)
        const { popupId, injectQSToPinia, openWorkerAllocateDialog, } = useWorkerAllocate();
        const lc = initAutoLc();
        /**
         * 다이얼로그 닫기 핸들러
         */
        const handleCloseDialog = () => {
            if (window.opener) {
                window.opener[popupId].close();
            }
        };
        onMounted(async () => {
            openWorkerAllocateDialog();
            if (!injectQSToPinia()) {
                await nextTick();
                vuexStore.dispatch(snackbarActionType.showError, lc('required_message'));
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(WorkerAllocate, {
                    draggable: false,
                    width: 0,
                    height: 0,
                    "on-close": handleCloseDialog,
                    "dialog-css-class": "popup-css-worker-allocate-dialog"
                })
            ]));
        };
    }
});
